import MGRAPI from '../interceptors/MgrApi';
import { queryClient } from '@/queryClient';

export const CLIENT_PROFILE_QUERY_KEY = ['clientProfile'];

const CLIENT_PROFILE_STALE_TIME = 30 * 1000;

export const userProfile = (data) => MGRAPI.put('/users', data);

export const getUserProfile = () => MGRAPI.get('/users/profile');

export const changeUserPassword = (data) => MGRAPI.post('/users/password', data);

export const clientProfile = (data) => MGRAPI.put('/clients', data).then((response) => {
  queryClient.invalidateQueries({ queryKey: CLIENT_PROFILE_QUERY_KEY });
  return response;
});

export const fetchClientProfile = () => MGRAPI.get('/clients/profile');

export const getClientProfile = () => queryClient.fetchQuery({
  queryKey: CLIENT_PROFILE_QUERY_KEY,
  queryFn: fetchClientProfile,
  staleTime: CLIENT_PROFILE_STALE_TIME,
}).then((profile) => (profile && typeof profile === 'object' ? { ...profile } : profile));

export const getPylonIdentity = () => MGRAPI.get('/clients/pylon-identity');

export const getAvailableClients = () => MGRAPI.get('/users/clients');

export const userResendEmail = (id) => MGRAPI.post(`/users/${id}/send`);

export const userLock = (id) => MGRAPI.put(`/users/${id}/lock`);

export const userUnlock = (id) => MGRAPI.put(`/users/${id}/unlock`);

export const update = (id, data) => MGRAPI.put(`/users/${id}`, data);

export const searchUsers = (params) => MGRAPI.get('/users/search', { params });

export const updateSecondaryContact = (id) => MGRAPI.patch(`/users/${id}/contact`);

export const removeSecondaryContact = () => MGRAPI.delete('/users/secondary-contact');

export const getUsers = (params?) => MGRAPI.get('/users/listAll', { params });

export const editUser = (userId, role) => MGRAPI.put(`users/${userId}/roles/${role}`);

export const deleteUser = (userId) => MGRAPI.delete(`users/${userId}`);

export const changeEnableMfa = (mfa, data) => MGRAPI.put(`/users/mfa/${mfa}`, data);

export const removeUserDevices = (userId) => MGRAPI.delete(`/users/${userId}/devices`);

export const unlockUser = (userId) => MGRAPI.put(`/users/${userId}/unlock`);

export const usersLoginLogs = (params) => MGRAPI.get('/users/login-logs', { params });

export const usersActivityLogs = (params) => MGRAPI.get('/users/activity-logs', { params });

export const sendMobileVerificationCode = () => MGRAPI.post('/users/profile/mobile/verification');

export const verifyMobile = (code: string) => MGRAPI.put('/users/profile/mobile/verification', { code });
